import { render, staticRenderFns } from "./AMenus.vue?vue&type=template&id=7f051ca2"
import script from "./AMenus.vue?vue&type=script&lang=js"
export * from "./AMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports